export default __webpack_public_path__ + "static/media/FR.6fd747b1.svg";